import { TableActionButton } from '@channelplay/table-actions';

/** A table-row status command with the same fixed icon design as other actions. */
export default function ActiveToggle({
  active,
  onToggle,
  label,
  onLabel = 'Click to deactivate',
  offLabel = 'Click to activate',
  disabled,
}: {
  active: boolean;
  onToggle: () => void;
  /** What is being toggled, for screen readers — e.g. the product name. */
  label: string;
  onLabel?: string;
  offLabel?: string;
  /** E.g. while the previous change is still saving. */
  disabled?: boolean;
}) {
  return (
    <TableActionButton
      action={active ? 'deactivate' : 'activate'}
      type="button"
      role="switch"
      aria-checked={active}
      label={`${active ? 'Deactivate' : 'Activate'} ${label}`}
      onClick={onToggle}
      title={active ? onLabel : offLabel}
      disabled={disabled}
    />
  );
}
